import React from "react";

const ClientCard = ({ props, index }) => {
  return (
    <div
      className="flex mx-8 p-2 lg:p-4 border border-[#a0a5e2] overflow-hidden bg-transparent  rounded-xl w-[300px] md:w-[450px] gap-4"
      data-aos="zoom-in-up"
      data-aos-duration={1000}
      data-aos-delay={400 + 300 * (index + 1)}
    >
      <div className="flex flex-col overflow-hidden bg-secondaryBg rounded-xl w-full gap-2 lg:gap-4 p-3 lg:p-4">
        <div className="flex h-full w-full justify-center items-center bg-transparent">
          <div className="flex h-40 w-40 lg:w-60 lg:h-60 rounded-full">
            <img
              src={props.img}
              className="w-full h-full rounded-full object-cover bg-cover"
              alt="client"
            />
          </div>
        </div>
        <div className="flex flex-col justify-center items-center gap-3 bg-transparent">
          <h1 className="text-xl lg:text-2xl font-bold bg-transparent text-center">
            {props.name}
          </h1>
          <div className="text-lg h-40 lg:h-36 bg-transparent text-center">
            {props.message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientCard;
